function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCircleSlash = function SvgCircleSlash(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M10 19A9 9 0 1 0 9.999.999 9 9 0 0 0 10 19Zm0-3a6.005 6.005 0 0 1-5.17-9.05l8.22 8.22c-.89.53-1.93.83-3.05.83ZM6.95 4.83a6.005 6.005 0 0 1 8.22 8.22L6.95 4.83Z",
    style: {
      fillRule: "evenodd"
    }
  }));
};
export default SvgCircleSlash;